import { graphql } from "react-relay";

export const load_school = graphql`
  query LoadSchoolQuery($schoolId: ID!) {
    school(id: $schoolId) {
      id
      name
      archived
      website
      schoolType
      headTeacher {
        id
        phoneNumber
        hasInvalidPhoneNumber
        user {
          id
          firstName
          lastName
          email
        }
      }
      mainOfficeContact {
        id
        phoneNumber
        hasInvalidPhoneNumber
        addressFirstLine
        addressSecondLine
        city
        postcode
        user {
          id
          firstName
          lastName
          email
        }
      }
      otherContacts {
        edges {
          node {
            id
            phoneNumber
            hasInvalidPhoneNumber
            label
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
`;
